<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle" v-if="IsAdd">动环设备添加</div>
          <div class="listtitle" v-if="IsEdit && !IsAdd">动环设备编辑</div>
          <div class="listtitle" v-if="!IsEdit && !IsAdd">动环设备详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <el-form-item
        label="设备名称"
        prop="DeviceName"
        style="display: inline-block"
      >
        <el-input
          v-model="ruleForm.DeviceName"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="设备编号"
        prop="DeviceNo"
        style="display: inline-block"
      >
        <el-input
          v-model="JsonExtend.DeviceNo"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>

      <el-form-item label="附近设备" prop="NearBy">
        <el-input
          type="NearBy"
          style="width: 50rem"
          v-model="JsonExtend.NearBy"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item label="区域" prop="RegionId" style="display: inline-block">
        <el-select
          v-model="ruleForm.RegionId"
          placeholder="请选择"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
        >
          <el-option
            v-for="item in RegionData"
            :key="item.RegionId"
            :label="item.RegionName"
            :value="item.RegionId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="IP地址" prop="Ip" style="display: inline-block">
        <el-input
          style="width: 50rem"
          v-model="JsonExtend.Ip"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item label="端口号" prop="Port" style="display: inline-block">
        <el-input
          style="width: 50rem"
          v-model="JsonExtend.Port"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item label="通道号" prop="Channel" style="display: inline-block">
        <el-input
          style="width: 50rem"
          v-model="JsonExtend.Channel"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item
        label="用户名"
        prop="UserName"
        style="display: inline-block"
      >
        <el-input
          style="width: 50rem"
          v-model="JsonExtend.UserName"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="Password" style="display: inline-block">
        <el-input
          style="width: 50rem"
          v-model="JsonExtend.Password"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item> -->
      <el-form-item label="经度" prop="Longitude" style="display: inline-block">
        <el-input
          style="width: 50rem"
          v-model="ruleForm.Longitude"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item label="纬度" prop="Latitude" style="display: inline-block">
        <el-input
          style="width: 45rem"
          v-model="ruleForm.Latitude"
          v-bind:disabled="!IsEdit"
        ></el-input>
        <!-- <el-button
          @click="getCurrentPostion()"
          style="width:8rem;"
          v-bind:disabled="!IsEdit"
          >定位</el-button
        > -->
        <ZjLngLatSelect
          :point_lat="ruleForm.Latitude"
          :point_lng="ruleForm.Longitude"
          style="margin-left: 0.5rem"
          @onGotLngLat="onGotLngLat"
        ></ZjLngLatSelect>
      </el-form-item>
      <el-form-item
        label="RTSP"
        prop="StartNumber"
        style="display: inline-block"
      >
        <el-input
          style="width: 50rem"
          v-model="JsonExtend.StartNumber"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="密度间值"
        prop="DensityAlarmThreshold"
        style="display: inline-block"
      >
        <el-input
          style="width: 50rem"
          v-model="JsonExtend.DensityAlarmThreshold"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>

      <el-form-item class="right" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >提交</el-button
        >
        <!--      <el-button @click="resetForm('')" :disabled="!IsEdit" v-if="IsEdit">重置</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../../../equipment/src/apis";
import ZJApp from "../../../../../app";

export default {
  name: "DynamicEnvEquipInfo",
  controller: "UI",
  action: "DynamicEnvEquipInfo",
  props: {
    query: {
      InfoId: String,
      type: String,
    },
  },
  data() {
    return {
      ruleForm: {
        DeviceId: null,
        DeviceName: "",
        DeviceType: "SubSystem.DynamicEnvironment", //设备类型
        IsOnline: false, //是否在线
        RegionId: null, //区域ID
        RegionName: null, //区域名称
        Latitude: null,
        Longitude: null,
        EquipmentType: "DynamicEnvironment",
      },
      rules: {
        DeviceName: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
        ],
        DeviceType: [
          { required: true, message: "请选择设备类型", trigger: "change" },
        ],
        // RegionId: [
        //   { required: true, message: "请选择区域", trigger: "change" },
        // ],
      },
      JsonExtend: {
        DeviceNo: null, //设备编号
        NearBy: null, //附近设备
        Ip: null,
        Port: null, //端口号
        Channel: null, //通道号
        UserName: null,
        Password: null,
        StartNumber: null, //rtsp
        DensityAlarmThreshold: null, //密度间值
      },
      IsEdit: false,
      IsAdd: false,
      DeviceTypesArr: [],
      RegionData: [],
    };
  },
  created: function () {

    if (this.$route.query.DeviceId) {
      this.search();
    }
    if (this.$route.query.type == "look") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
    if (this.$route.query.type == "add") {
      this.IsAdd = true;
    } else {
      this.IsAdd = false;
    }
    // 设备类型
    this.basedataRegion(); //区域列表
  },
  mounted: function () {},
  watch: {
    $route: function () {
      if (this.$route.query.DeviceId) {
        this.search();
      }
    },
  },
  methods: {
    basedataRegion() {
      let searchInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      new MyApis.RegionApi()
        .GetRegionInfos(searchInfo)
        .then((r) => {
          // console.log("区域")
          // console.log(r)
          this.RegionData = r.data.Data;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    search() {
      let DeviceId = this.$route.query.DeviceId;
      let that = this;
      if (DeviceId) {
        let searchInfo = { DeviceId: DeviceId };
        new MyApis.MonitorApi()
          .GetEquipmentById(searchInfo)
          .then((r) => {
            r = r.data.Data;
            // console.log(r);
            that.ruleForm = r;
            that.JsonExtend = JSON.parse(r.JsonExtend);
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    onGotLngLat(obj) {
      this.ruleForm.Latitude = obj.lat;
      this.ruleForm.Longitude = obj.lng;
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    save() {
      this.saveData();
    },
    saveData() {
      this.RegionData.forEach((item) => {
        if (item.RegionId == this.ruleForm.RegionId) {
          this.ruleForm.RegionName = item.RegionName;
        }
      });
      if (this.ruleForm.Longitude != null) {
        this.ruleForm.Longitude = Number(this.ruleForm.Longitude);
      }
      if (this.ruleForm.Latitude != null) {
        this.ruleForm.Latitude = Number(this.ruleForm.Latitude);
      }
      this.ruleForm.JsonExtend = JSON.stringify(this.JsonExtend);
      if (this.$route.query.type == "edit") {
        //编辑
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          Validity: 1, //新增编辑是1，删除是0
        };
        let formAll = Object.assign(formObj, this.ruleForm);
        new MyApis.MonitorApi()
          .UpdateEquipment(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "动环设备修改";
            this.logInfo.LogMessage = "动环设备修改";
            this.logInfo.ModuleName = "动环监测";
            this.logInfo.PageName = "动环设备管理详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          Modifier: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          ModifyTime: new Date(),
          Validity: 1, //新增编辑是1，删除是0
        };
        let formAll = Object.assign(formObj, this.ruleForm);
        new MyApis.MonitorApi()
          .AddEquipment(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "动环设备添加";
            this.logInfo.LogMessage = "动环设备添加";
            this.logInfo.ModuleName = "动环监测";
            this.logInfo.PageName = "动环设备管理详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    },
  },
};
</script>
<style type="text/css"></style>
